module.exports = __webpack_public_path__ + "img/LIBTOP.267aa699.png";